module.exports = __webpack_public_path__ + "img/No-Image-Placeholder.svg.6a8b91cb.png";